/**
 * French translations
 */
import type { Translations } from "./en";

export const fr: Translations = {
  errors: {
    roomNoEmail: "Cette salle n'a pas d'adresse email configurée. Veuillez contacter votre administrateur.",
    roomAlreadyBooked: "Cette salle est déjà réservée pour cet horaire. Essayez une autre salle.",
    bookingFailed: "Impossible d'ajouter la salle à l'événement",
    networkError: "Vérifiez votre connexion Internet et réessayez. Si le problème persiste, essayez de vous reconnecter.",
    authError: "Veuillez vous reconnecter.",
    authRequired: "Authentification requise",
    authFailed: "Échec de l'authentification. Veuillez réessayer.",
    accountNotFound: "Aucun compte Deskare n'est associé à l'email {email}. Merci de contacter votre administrateur.",
    userCancelled: "La connexion a été annulée. Réessayez quand vous êtes prêt.",
    accountNotSupported: "Ce type de compte n'est pas pris en charge. Connectez-vous avec un compte Microsoft 365 professionnel ou scolaire.",
    popupBlocked: "La fenêtre de connexion a été bloquée par votre navigateur. Autorisez les pop-ups pour cet add-in puis réessayez.",
    consentRequired: "Le consentement de l'administrateur est requis. Merci de demander à votre administrateur d'approuver cet add-in.",
    apiNotAvailable: "Le service d'identité Microsoft n'est pas disponible dans cette version d'Outlook. Mettez Outlook à jour puis réessayez.",
    validationError: "Vérifiez vos données et réessayez.",
    unknownError: "Une erreur inattendue s'est produite.",
    outlookContextUnavailable: "Le contexte Office n'est pas disponible",
    outlookNoAppointment: "Aucun rendez-vous actif",
    outlookCannotUpdateLocation: "Impossible de mettre à jour la localisation",
    outlookCannotAddAttendee: "Impossible d'ajouter le participant",
    outlookCannotStoreData: "Impossible de sauvegarder les données",
  },
  success: {
    roomAdded: "La salle a été ajoutée à votre événement.",
  },
  ui: {
    // Buttons
    addRoom: "Ajouter la salle",
    addingRoom: "Ajout en cours...",
    addAnotherRoom: "Ajouter une autre salle",
    done: "Terminé",
    close: "Fermer",
    viewOtherRooms: "Voir autres salles",
    searchRooms: "Rechercher des salles",
    reconnect: "Se reconnecter",

    // Status badges
    roomFree: "Disponible",
    roomBooked: "Réservée",

    // Dialog
    roomAddedTitle: "Salle ajoutée !",
    roomAddedDescription: "La salle a été ajoutée à votre événement et définie comme lieu.",

    // Loading states
    loadingAppointment: "Chargement des détails du rendez-vous...",

    // Filters
    filters: "Filtres",
    minCapacity: "Capacité minimum",
    equipment: "Équipements",

    // Empty states
    noRoomsFound: "Aucune salle trouvée",
    adjustFilters: "Essayez de modifier vos filtres",
    roomFound: "salle trouvée",
    roomsFound: "salles trouvées",

    // Room details
    capacity: "Capacité",
    attendee: "participant",
    attendees: "participants",
    tabsRooms: "Salles",
    tabsInsights: "Contexte",
    tabsShortlist: "Favoris",
    meetingSummary: "Résumé de la réunion",
    insightsTitle: "Préparer la réunion",
    recommendedRooms: "Salles mises en avant pour ce créneau",
    timeWindow: "Créneau",
    noShortlist: "Lancez une recherche pour préparer une sélection",

    // New UI labels for redesign
    recommendedForYou: "Recommandé pour vous",
    refineSearch: "Affiner la recherche",
    people: "personnes",
    allRooms: "Toutes les salles",
    loadingRooms: "Chargement des salles...",
    tryAdjustFilters: "Essayez d'ajuster les filtres",
    noSubject: "Sans objet",
    organizer: "Organisateur",
    you: "Vous",
    location: "Lieu",
    more: "de plus",
    confirmed: "Confirmée",
    changeRoom: "Changer de salle",
    cancelReservation: "Annuler la réservation",
    loadingReservations: "Chargement des réservations...",
    errorLoadingReservations: "Erreur de chargement des réservations",
    currentMeetingReservation: "Réservation de la réunion actuelle",
    noReservations: "Aucune réservation",
    noReservationsDescription: "Vous n'avez aucune salle réservée pour cette réunion",
    tabsBook: "Réserver",
    tabsReservations: "Mes Réservations",
    cancel: "Annuler",
    allOfficesLabel: "Tous les sites",
    office: "Site",
    signOut: "Se déconnecter",
    signIn: "Se connecter",
    signedOutMessage: "Vous avez été déconnecté.",
  },
  errorContext: {
    conflict: "Cette salle est déjà réservée pour cet horaire. Essayez une autre salle.",
    network: "Vérifiez votre connexion Internet et réessayez. Si le problème persiste, essayez de vous reconnecter.",
    auth: "Veuillez vous reconnecter.",
    validation: "Vérifiez vos données et réessayez.",
  },
};
